import { useDocumentTitle } from "@/lib/use-document-title";
import { LegalLayout } from "@/components/LegalLayout";

export default function VillkorPage() {
  useDocumentTitle("Medlemsvillkor — Lagamobilen Access");
  return (
    <LegalLayout title="Medlemsvillkor" updated="Senast uppdaterad 16 juni 2026">

      <section>
        <h2>
          <span className="section-number">1</span>
          Allmänt om medlemskapet
        </h2>
        <p>
          Dessa villkor gäller för medlemskapet <strong>Lagamobilen Access</strong>{" "}
          (nedan "Medlemskapet") som tillhandahålls av:
        </p>
        <div className="contact-block">
          <p className="font-semibold">ResQ My Device AB</p>
          <p>Organisationsnummer: 559149-4496</p>
          <p>Hyllie stationsväg 10, 215 32 Malmö</p>
          <p>
            E-post:{" "}
            <a href="mailto:access@lagamobilen.se">access@lagamobilen.se</a> · Telefon: 040-125600
          </p>
        </div>
        <p>
          Genom att teckna Medlemskapet godkänner du (nedan "Medlemmen") dessa villkor.
          Medlemskapet är personligt och får inte överlåtas.
        </p>
      </section>

      <section>
        <h2>
          <span className="section-number">2</span>
          Vad Medlemskapet ger
        </h2>
        <ul>
          <li>Kostnadsfri personlig hjälp av tekniker</li>
          <li>Prioriterad service och fri felsökning</li>
          <li>20 % rabatt på reparationer</li>
          <li>50 % rabatt på tillbehör (en gång per månad)</li>
          <li>Fri rensning av telefon eller dator (en gång per månad)</li>
          <li>Tillgång till medlemskvällar och utbildningar</li>
          <li>Exklusiva eventkvällar och erbjudanden</li>
        </ul>
      </section>

      <section>
        <h2>
          <span className="section-number">3</span>
          Pris och betalning
        </h2>
        <p>
          Medlemskapet kostar <strong>99 kr per månad inklusive moms</strong>. Betalning sker via
          återkommande kortbetalning genom vår betaltjänstleverantör Stripe. Du debiteras direkt vid
          tecknandet för innevarande månad, och därefter månadsvis.
        </p>
        <p>
          Kortuppgifter hanteras och lagras uteslutande av Stripe. ResQ My Device AB lagrar aldrig
          dina fullständiga kortuppgifter.
        </p>
      </section>

      <section>
        <h2>
          <span className="section-number">4</span>
          Bindningstid och uppsägning
        </h2>
        <p>
          Medlemskapet har en <strong>minsta löptid om 3 månader</strong> räknat från
          tecknandet. Du kan när som helst säga upp Medlemskapet via kundportalen
          ("Min profil" → "Avsluta medlemskap") eller genom att mejla{" "}
          <a href="mailto:access@lagamobilen.se">access@lagamobilen.se</a>.
        </p>
        <p>
          <strong>Uppsägning inom bindningstiden:</strong> Medlemskapet upphör vid
          bindningstidens slut. Månadsavgiften (99 kr) debiteras löpande fram tills
          dess. Du behåller full tillgång till alla förmåner under hela perioden.
        </p>
        <p>
          <strong>Uppsägning efter bindningstiden:</strong> Medlemskapet upphör vid
          slutet av innevarande betalperiod. Ingen ytterligare debitering sker.
        </p>
        <p>
          Befintliga medlemmar som tecknade Medlemskapet före {`16 juni 2026`} omfattas inte
          av bindningstid utan kan säga upp utan minsta löptid.
        </p>
      </section>

      <section>
        <h2>
          <span className="section-number">5</span>
          Ångerrätt
        </h2>
        <p>
          Du har 14 dagars ångerrätt enligt lag (2005:59). Läs mer på sidan{" "}
          <a href="/access/angerratt">Information om ångerrätt</a>.
        </p>
      </section>

      <section>
        <h2>
          <span className="section-number">6</span>
          Personuppgifter
        </h2>
        <p>
          Behandling av personuppgifter beskrivs i vår{" "}
          <a href="/access/integritetspolicy">Integritetspolicy</a>.
        </p>
      </section>

      <section>
        <h2>
          <span className="section-number">7</span>
          Ansvarsbegränsning
        </h2>
        <p>
          ResQ My Device AB ansvarar inte för indirekta skador. Ansvar begränsas till det belopp
          Medlemmen erlagt för Medlemskapet under den senaste 12-månadersperioden.
        </p>
      </section>

      <section>
        <h2>
          <span className="section-number">8</span>
          Ändringar av villkor
        </h2>
        <p>
          Vi förbehåller oss rätten att ändra dessa villkor. Väsentliga ändringar meddelas via
          e-post minst 30 dagar i förväg.
        </p>
      </section>

      <section>
        <h2>
          <span className="section-number">9</span>
          Tvist
        </h2>
        <p>
          Tvist prövas av svensk allmän domstol med Malmö tingsrätt som första instans. Du har
          även rätt att vända dig till Allmänna reklamationsnämnden (ARN).
        </p>
      </section>
    </LegalLayout>
  );
}
